import { render, staticRenderFns } from "./CompanyAssociationsList.vue?vue&type=template&id=4ceaead0&scoped=true"
import script from "./CompanyAssociationsList.vue?vue&type=script&lang=js"
export * from "./CompanyAssociationsList.vue?vue&type=script&lang=js"
import style0 from "./CompanyAssociationsList.vue?vue&type=style&index=0&id=4ceaead0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceaead0",
  null
  
)

export default component.exports